import React from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'react-bootstrap';

import { store } from './app/store';

import Report from './pages/report/Report';
import Reports from './pages/reports/Reports';
import AppPage from './features/appPage/AppPage';
import IntroPage from './pages/intro/IntroPage';
import Oss from './pages/oss/Oss';
import LandingLoginPage from './pages/landingLoginPage/LandingLoginPage';
import Datenschutz from './pages/datenschutz/Datenschutz';
import Impressum from './pages/impressum/Impressum';
import Nutzungsbedingungen from './pages/nutzungsbedingungen/Nutzungsbedingungen';

import appStyles from './css/App.module.css';
import ProtectRoute from './features/ProtectionRoute/ProtectionRoute';
import PageNotFound from './pages/pageNotFound/PageNotFound';

const App: React.FC = () => (
  <Provider store={store}>
    <BrowserRouter>
      <ThemeProvider
        breakpoints={['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs']}
        minBreakpoint="xs"
      >
        <div data-testid="app-main-element" className={[appStyles.mainContainer, appStyles.App].join(' ')}>
          <Routes>
            <Route path="/" element={<LandingLoginPage />} />
            <Route element={<AppPage />}>
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/datenschutz" element={<Datenschutz />} />
              <Route path="/nutzungsbedingungen" element={<Nutzungsbedingungen />} />
            </Route>
            <Route element={<ProtectRoute onNotAuthenticatedRedirectURL="/" />}>
              <Route element={<AppPage />}>
                <Route path="/intro" element={<IntroPage />} />
                <Route path="/oss" element={<Oss />} />
                <Route path="/report">
                  <Route index element={<Reports />} />
                  <Route path=":reportId" element={<Report />} />
                </Route>
              </Route>
            </Route>
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </div>
      </ThemeProvider>
    </BrowserRouter>
  </Provider>
);

export default App;
